var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermsOfUse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.14,
    y: 68.96,
    width: 291.22,
    height: 210.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.37,247.67c.28-.55,2.09,1.29,2.09,1.29,1.47,1.47,12.45,12.45,14.42,12.45s37.32,11.82,37.32,11.82l27.95-7.6C318.6,272,310.26,284,310.26,284s-21.82,1.72-26,0-34.57-18.63-34.57-18.63-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74c-.49-.74-.73-.74-2.45-2.21a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79a8.64,8.64,0,0,1-1.11-1.67c-.44-1,.26-1.28.26-1.28S234.09,248.23,234.37,247.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.87,248.44a25.89,25.89,0,0,1,5.4,3.38,44.29,44.29,0,0,1,4,5.49S236.7,250.09,235.87,248.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.48,250.71c-.44-1,.26-1.28.26-1.28s-.65-1.2-.37-1.76,2.09,1.29,2.09,1.29c1.47,1.47,12.45,12.45,14.42,12.45,1,0,10.38,3,19.5,5.95l-3.53,7.48c-8.64-4.71-17.15-9.45-17.15-9.45s-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74c-.49-.74-.73-.74-2.45-2.21a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79A8.64,8.64,0,0,1,234.48,250.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.9,317.37s8.82,6.38,10.05,12.26,3.43,15.94,3.68,17.16,10.54,35.56,10.79,36.78S376,392.4,375.73,400s4.42,42.91,4.66,45.12-2,3.43-4.17,4.66-6.63,5.77-11.77,2.94c-4-2.18,9.32-10.05,9.32-14s-13-39.47-16.67-46.83S344.59,367.15,341.9,363a60.78,60.78,0,0,1-4.66-9.07s-.74,16.18,1.22,24.52,3.68,21.57,1,34.57-3.43,25.74-2.69,29.91-.49,4.42-2.95,5.15-7.13-.15-10.07,1.11-8.87,1-9.28-1,9.55-6,12.73-8.43,2.21-6.62,2.95-16.68-5.4-35.8-6.38-41.44-6.87-26.48-6.87-38.25.74-16.67.74-16.67,3.43-3.43,10.79-6.62A31.08,31.08,0,0,1,341.9,317.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.56,236.56c0-1.88-1.73-8.55,3.07-12.93s13.24-3.39,13.24-3.39c10,.68,15.91,12.14,13.89,20.22s-7.82,9-9.84,11.6c-1.1,1.38-.34,5,.59,8,8.6.39,7.95,7.22,9.54,12,2,5.88,4.66,24.52,5.39,28.69s6.13,11.28,6.13,13.73-10.79,6.37-20.1,11-9.17,4.89-10.89,2.43S311,300.94,311,298s-8.83-10.3-6.87-14.47c1.58-3.36,8.73-15.94,11.45-20.7l-.15-.53a72.64,72.64,0,0,0-3.91-8.76s-5.13.27-6.61.13-2.29-.54-2.56-1.88a6.77,6.77,0,0,1,.4-3.1s-.53.13-.8-.68.67-1.48.67-1.48c-.67-.27-.68-1.6-.68-1.6l1.25-1.26s-2.19-.62-2.4-2.29S303.56,238.43,303.56,236.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.25,242.45s3.1-5.19,6.21-3.58-.74,6.84-3.11,8.15-3.25-2-3.25-2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.62,270.05s5.39-8.58,11.77-6.13,27.22,29.18,27.95,33.34,6.38,38.26,6.38,38.26,1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-12.5-28.68-13-31.38a15.21,15.21,0,0,0-1.47-4.42s-22.56-18.63-24.77-22.06",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.89,300.49c1.62,9.62,5.83,35,5.83,35s1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-11.41-26.18-12.86-30.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.67,186.47S50.62,255.05,95.33,314.8,218,397.78,280.6,418.25s121.31-3.16,143.32-55.8-22.45-81-32.25-149.75-2-88.56-47.7-140.91-139.55-51.1-203,2.65S66.67,186.47,66.67,186.47Z",
    style: {
      fill: "#929292"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.67,186.47S50.62,255.05,95.33,314.8,218,397.78,280.6,418.25s121.31-3.16,143.32-55.8-22.45-81-32.25-149.75-2-88.56-47.7-140.91-139.55-51.1-203,2.65S66.67,186.47,66.67,186.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.36,450.3c0,2.94-70.37,5.31-157.18,5.31S85,453.24,85,450.3s70.37-5.3,157.18-5.3S399.36,447.37,399.36,450.3Z",
    style: {
      fill: "#929292"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.36,450.3c0,2.94-70.37,5.31-157.18,5.31S85,453.24,85,450.3s70.37-5.3,157.18-5.3S399.36,447.37,399.36,450.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.62,284.78c-.06,0,.69-3.73.77-4,.86-2.66,4.1-7.3,7.23-7.3a3.72,3.72,0,0,1,3.57,4.22c-.23,2.2-2.21,4.08-4,5.16C136.1,284.17,130.62,284.78,130.62,284.78Z",
    style: {
      fill: "#929292"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.55,259.66c3,1.06,4.42,6.52,4.32,9.32,0,.24-.56,4-.61,4l-.06,0c.23.86.48,1.78.73,2.8.44,1.88.92,4,1.29,6.36a65.63,65.63,0,0,1,.84,7.64,48.28,48.28,0,0,1-.29,8.6.44.44,0,0,0,0,.1c.39-.83,1.55-3.12,1.65-3.29,1.54-2.34,5.88-6,8.91-5.13a3.7,3.7,0,0,1,2.32,5c-.8,2.07-3.2,3.35-5.21,3.93-2.27.64-7.33-.12-7.73-.18a65.64,65.64,0,0,1-1.86,8.56q-.71,2.46-1.52,4.91c.35-.71.68-1.34.73-1.42,1.54-2.34,5.89-6,8.91-5.13a3.7,3.7,0,0,1,2.32,5c-.8,2.06-3.2,3.35-5.21,3.92s-6.37,0-7.51-.14l-.63,1.87c-1,3-2.09,6-3,8.94-.33,1-.62,2.08-.91,3.12.32-.63.59-1.16.64-1.23,1.53-2.35,5.88-6,8.9-5.13a3.71,3.71,0,0,1,2.33,5c-.8,2.06-3.21,3.35-5.22,3.92s-5.94.07-7.3-.12c-.27,1.07-.53,2.15-.74,3.2-.13.72-.3,1.4-.39,2.14l-.3,2.14c-.14,1.37-.3,2.78-.4,4.12-.08.94-.14,1.83-.2,2.72.32-1,1-3.07,1-3.23a14.5,14.5,0,0,1,4.8-5.46,4.3,4.3,0,0,1,.41-.72,3.7,3.7,0,0,1,5.45-.85c2.38,2.05,1.78,7.67.69,10.25-.06.15-1,1.73-1.52,2.71.43-.53.83-1,1.28-1.58.87-1.07,1.77-2.11,2.73-3.23q.74-.78,1.47-1.59c.48-.54,1.06-1.05,1.59-1.59,1.25-1.21,2.58-2.38,4-3.52-.93-.77-4.21-3.53-5.15-5.41s-1.61-4.51-.63-6.5a3.71,3.71,0,0,1,5.27-1.66c2.65,1.66,2.92,7.31,2.23,10,0,.17-.76,2.07-1.17,3.1.83-.69,1.65-1.37,2.51-2,2.48-1.91,5-3.77,7.6-5.64l2.33-1.73c-.33-.27-4.29-3.47-5.35-5.58-.93-1.87-1.61-4.51-.63-6.49a3.71,3.71,0,0,1,5.27-1.67c2.66,1.67,2.92,7.31,2.23,10-.05.2-1.08,2.92-1.37,3.6,1.7-1.27,3.39-2.55,5-3.88a66,66,0,0,0,6.2-5.78c-.15-.12-4.3-3.45-5.38-5.6-.94-1.87-1.61-4.51-.63-6.5a3.71,3.71,0,0,1,5.26-1.67c2.66,1.67,2.93,7.32,2.24,10-.05.18-.83,2.26-1.22,3.23a.78.78,0,0,0,.15.1,47.88,47.88,0,0,0,5.09-6.84c.83-1.32,1.56-2.64,2.24-3.93-.84-.54-4.63-3.05-5.82-4.88s-2.09-4.31-1.34-6.39a3.7,3.7,0,0,1,5-2.23c2.83,1.36,3.71,6.95,3.32,9.72,0,.15-.4,1.66-.69,2.75.29-.58.61-1.19.88-1.76,1-2.13,1.85-4.15,2.55-5.94.4-1,.73-2,1-2.84-.55-.95-2.69-4.84-2.9-7s.13-4.79,1.76-6.29a3.71,3.71,0,0,1,5.51.34c1.88,2.51.09,7.88-1.53,10.16-.14.2-2.69,3-2.72,3l0-.06c-.28.85-.58,1.75-.94,2.74-.66,1.81-1.43,3.85-2.42,6a67.92,67.92,0,0,1-3.53,6.84,48.53,48.53,0,0,1-5,7l-.07.07c.78-.48,3-1.75,3.19-1.83,2.58-1.11,8.2-1.73,10.26.63a3.71,3.71,0,0,1-.82,5.46c-1.81,1.28-4.52,1-6.52.4-2.25-.71-6-4.14-6.34-4.41a66.15,66.15,0,0,1-6.28,6.11c-1.29,1.11-2.63,2.19-4,3.26.69-.39,1.31-.74,1.4-.78,2.57-1.11,8.19-1.73,10.25.63a3.7,3.7,0,0,1-.82,5.46c-1.8,1.28-4.52,1-6.51.4s-5.32-3.5-6.18-4.27c-.53.41-1,.82-1.57,1.22-2.51,1.93-5,3.84-7.45,5.79-.85.69-1.66,1.39-2.48,2.1l1.22-.68c2.57-1.1,8.19-1.73,10.25.64a3.7,3.7,0,0,1-.82,5.46c-1.81,1.28-4.52,1-6.51.39s-5-3.22-6-4.12c-.81.74-1.63,1.49-2.38,2.25-.51.53-1,1-1.5,1.57l-1.44,1.63c-.87,1.06-1.78,2.15-2.61,3.21-.58.74-1.12,1.45-1.66,2.16.83-.69,2.51-2,2.66-2.11,2.37-1.49,7.84-2.95,10.23-.93a3.71,3.71,0,0,1,0,5.52c-1.6,1.54-4.32,1.7-6.38,1.38-2.28-.35-6.4-3-6.91-3.37-.9,1.18-1.76,2.34-2.56,3.44-2.77,3.83-4.93,7.13-6.41,9.45l-.15.24-1.92-.93.3-.46c1.55-2.31,3.81-5.59,6.69-9.4.91-1.21,1.9-2.47,2.93-3.77a40,40,0,0,1-3-3.68c-2.21.86-6.79.89-7.39.89-.09,1.49-.17,2.93-.23,4.29-.2,4.73-.18,8.67-.13,11.42v.32l-2.11-1c0-2.74.11-6.44.39-10.82.09-1.5.22-3.11.37-4.76-.59-.14-5.36-1.37-7.16-2.81-1.63-1.3-3.35-3.42-3.29-5.63a3.7,3.7,0,0,1,4.08-3.72c3.11.4,5.72,5.41,6.23,8.17,0,.16.16,2,.22,3.09.07-.67.12-1.32.2-2,.13-1.37.31-2.73.5-4.2.11-.7.23-1.42.34-2.14s.3-1.46.45-2.19c.38-1.71.84-3.42,1.35-5.13-1.2-.12-5.45-.62-7.28-1.67s-3.83-2.87-4.1-5.07a3.7,3.7,0,0,1,3.47-4.29c3.13-.08,6.47,4.48,7.39,7.13.06.16.51,2.13.74,3.22.31-1,.61-2.05,1-3.08,1-3,2.13-5.93,3.23-8.9.34-.91.66-1.82,1-2.73-.43,0-5.5-.52-7.54-1.7-1.81-1-3.83-2.87-4.11-5.07a3.71,3.71,0,0,1,3.47-4.29c3.14-.08,6.48,4.49,7.4,7.13.07.2.71,3,.84,3.77.72-2,1.43-4,2-6a65.26,65.26,0,0,0,2-8.24c-.2,0-5.49-.5-7.58-1.7-1.82-1-3.84-2.88-4.11-5.08a3.7,3.7,0,0,1,3.47-4.29c3.13-.08,6.47,4.49,7.39,7.13.06.17.56,2.34.77,3.37h.17a47.81,47.81,0,0,0,.48-8.51c0-1.56-.15-3.06-.3-4.51-1,0-5.54,0-7.54-.86s-4.13-2.44-4.65-4.59a3.71,3.71,0,0,1,3-4.65c3.11-.42,6.93,3.75,8.14,6.27.06.14.58,1.61.93,2.69-.07-.66-.14-1.33-.23-2-.31-2.35-.75-4.48-1.15-6.37-.24-1.07-.47-2-.7-2.93-1-.5-4.92-2.55-6.26-4.22s-2.54-4.06-2-6.21A3.71,3.71,0,0,1,124.55,259.66Z",
    style: {
      fill: "#929292"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23,308c-2.45-.1-7.35-2.62-7.35-2.62s2.63-2.72,2.82-2.88c2.19-1.74,7.45-3.83,10.06-2.09a3.7,3.7,0,0,1,.65,5.48C186,307.6,183.32,308.08,181.23,308Z",
    style: {
      fill: "#929292"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.62,284.78c-.06,0,.69-3.73.77-4,.86-2.66,4.1-7.3,7.23-7.3a3.72,3.72,0,0,1,3.57,4.22c-.23,2.2-2.21,4.08-4,5.16C136.1,284.17,130.62,284.78,130.62,284.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.55,259.66c3,1.06,4.42,6.52,4.32,9.32,0,.24-.56,4-.61,4l-.06,0c.23.86.48,1.78.73,2.8.44,1.88.92,4,1.29,6.36a65.63,65.63,0,0,1,.84,7.64,48.28,48.28,0,0,1-.29,8.6.44.44,0,0,0,0,.1c.39-.83,1.55-3.12,1.65-3.29,1.54-2.34,5.88-6,8.91-5.13a3.7,3.7,0,0,1,2.32,5c-.8,2.07-3.2,3.35-5.21,3.93-2.27.64-7.33-.12-7.73-.18a65.64,65.64,0,0,1-1.86,8.56q-.71,2.46-1.52,4.91c.35-.71.68-1.34.73-1.42,1.54-2.34,5.89-6,8.91-5.13a3.7,3.7,0,0,1,2.32,5c-.8,2.06-3.2,3.35-5.21,3.92s-6.37,0-7.51-.14l-.63,1.87c-1,3-2.09,6-3,8.94-.33,1-.62,2.08-.91,3.12.32-.63.59-1.16.64-1.23,1.53-2.35,5.88-6,8.9-5.13a3.71,3.71,0,0,1,2.33,5c-.8,2.06-3.21,3.35-5.22,3.92s-5.94.07-7.3-.12c-.27,1.07-.53,2.15-.74,3.2-.13.72-.3,1.4-.39,2.14l-.3,2.14c-.14,1.37-.3,2.78-.4,4.12-.08.94-.14,1.83-.2,2.72.32-1,1-3.07,1-3.23a14.5,14.5,0,0,1,4.8-5.46,4.3,4.3,0,0,1,.41-.72,3.7,3.7,0,0,1,5.45-.85c2.38,2.05,1.78,7.67.69,10.25-.06.15-1,1.73-1.52,2.71.43-.53.83-1,1.28-1.58.87-1.07,1.77-2.11,2.73-3.23q.74-.78,1.47-1.59c.48-.54,1.06-1.05,1.59-1.59,1.25-1.21,2.58-2.38,4-3.52-.93-.77-4.21-3.53-5.15-5.41s-1.61-4.51-.63-6.5a3.71,3.71,0,0,1,5.27-1.66c2.65,1.66,2.92,7.31,2.23,10,0,.17-.76,2.07-1.17,3.1.83-.69,1.65-1.37,2.51-2,2.48-1.91,5-3.77,7.6-5.64l2.33-1.73c-.33-.27-4.29-3.47-5.35-5.58-.93-1.87-1.61-4.51-.63-6.49a3.71,3.71,0,0,1,5.27-1.67c2.66,1.67,2.92,7.31,2.23,10-.05.2-1.08,2.92-1.37,3.6,1.7-1.27,3.39-2.55,5-3.88a66,66,0,0,0,6.2-5.78c-.15-.12-4.3-3.45-5.38-5.6-.94-1.87-1.61-4.51-.63-6.5a3.71,3.71,0,0,1,5.26-1.67c2.66,1.67,2.93,7.32,2.24,10-.05.18-.83,2.26-1.22,3.23a.78.78,0,0,0,.15.1,47.88,47.88,0,0,0,5.09-6.84c.83-1.32,1.56-2.64,2.24-3.93-.84-.54-4.63-3.05-5.82-4.88s-2.09-4.31-1.34-6.39a3.7,3.7,0,0,1,5-2.23c2.83,1.36,3.71,6.95,3.32,9.72,0,.15-.4,1.66-.69,2.75.29-.58.61-1.19.88-1.76,1-2.13,1.85-4.15,2.55-5.94.4-1,.73-2,1-2.84-.55-.95-2.69-4.84-2.9-7s.13-4.79,1.76-6.29a3.71,3.71,0,0,1,5.51.34c1.88,2.51.09,7.88-1.53,10.16-.14.2-2.69,3-2.72,3l0-.06c-.28.85-.58,1.75-.94,2.74-.66,1.81-1.43,3.85-2.42,6a67.92,67.92,0,0,1-3.53,6.84,48.53,48.53,0,0,1-5,7l-.07.07c.78-.48,3-1.75,3.19-1.83,2.58-1.11,8.2-1.73,10.26.63a3.71,3.71,0,0,1-.82,5.46c-1.81,1.28-4.52,1-6.52.4-2.25-.71-6-4.14-6.34-4.41a66.15,66.15,0,0,1-6.28,6.11c-1.29,1.11-2.63,2.19-4,3.26.69-.39,1.31-.74,1.4-.78,2.57-1.11,8.19-1.73,10.25.63a3.7,3.7,0,0,1-.82,5.46c-1.8,1.28-4.52,1-6.51.4s-5.32-3.5-6.18-4.27c-.53.41-1,.82-1.57,1.22-2.51,1.93-5,3.84-7.45,5.79-.85.69-1.66,1.39-2.48,2.1l1.22-.68c2.57-1.1,8.19-1.73,10.25.64a3.7,3.7,0,0,1-.82,5.46c-1.81,1.28-4.52,1-6.51.39s-5-3.22-6-4.12c-.81.74-1.63,1.49-2.38,2.25-.51.53-1,1-1.5,1.57l-1.44,1.63c-.87,1.06-1.78,2.15-2.61,3.21-.58.74-1.12,1.45-1.66,2.16.83-.69,2.51-2,2.66-2.11,2.37-1.49,7.84-2.95,10.23-.93a3.71,3.71,0,0,1,0,5.52c-1.6,1.54-4.32,1.7-6.38,1.38-2.28-.35-6.4-3-6.91-3.37-.9,1.18-1.76,2.34-2.56,3.44-2.77,3.83-4.93,7.13-6.41,9.45l-.15.24-1.92-.93.3-.46c1.55-2.31,3.81-5.59,6.69-9.4.91-1.21,1.9-2.47,2.93-3.77a40,40,0,0,1-3-3.68c-2.21.86-6.79.89-7.39.89-.09,1.49-.17,2.93-.23,4.29-.2,4.73-.18,8.67-.13,11.42v.32l-2.11-1c0-2.74.11-6.44.39-10.82.09-1.5.22-3.11.37-4.76-.59-.14-5.36-1.37-7.16-2.81-1.63-1.3-3.35-3.42-3.29-5.63a3.7,3.7,0,0,1,4.08-3.72c3.11.4,5.72,5.41,6.23,8.17,0,.16.16,2,.22,3.09.07-.67.12-1.32.2-2,.13-1.37.31-2.73.5-4.2.11-.7.23-1.42.34-2.14s.3-1.46.45-2.19c.38-1.71.84-3.42,1.35-5.13-1.2-.12-5.45-.62-7.28-1.67s-3.83-2.87-4.1-5.07a3.7,3.7,0,0,1,3.47-4.29c3.13-.08,6.47,4.48,7.39,7.13.06.16.51,2.13.74,3.22.31-1,.61-2.05,1-3.08,1-3,2.13-5.93,3.23-8.9.34-.91.66-1.82,1-2.73-.43,0-5.5-.52-7.54-1.7-1.81-1-3.83-2.87-4.11-5.07a3.71,3.71,0,0,1,3.47-4.29c3.14-.08,6.48,4.49,7.4,7.13.07.2.71,3,.84,3.77.72-2,1.43-4,2-6a65.26,65.26,0,0,0,2-8.24c-.2,0-5.49-.5-7.58-1.7-1.82-1-3.84-2.88-4.11-5.08a3.7,3.7,0,0,1,3.47-4.29c3.13-.08,6.47,4.49,7.39,7.13.06.17.56,2.34.77,3.37h.17a47.81,47.81,0,0,0,.48-8.51c0-1.56-.15-3.06-.3-4.51-1,0-5.54,0-7.54-.86s-4.13-2.44-4.65-4.59a3.71,3.71,0,0,1,3-4.65c3.11-.42,6.93,3.75,8.14,6.27.06.14.58,1.61.93,2.69-.07-.66-.14-1.33-.23-2-.31-2.35-.75-4.48-1.15-6.37-.24-1.07-.47-2-.7-2.93-1-.5-4.92-2.55-6.26-4.22s-2.54-4.06-2-6.21A3.71,3.71,0,0,1,124.55,259.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23,308c-2.45-.1-7.35-2.62-7.35-2.62s2.63-2.72,2.82-2.88c2.19-1.74,7.45-3.83,10.06-2.09a3.7,3.7,0,0,1,.65,5.48C186,307.6,183.32,308.08,181.23,308Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.62,369.35s-14.87-35.84-23.19-34.28,14.27,57.14,14.27,57.14-26.16-49.35-44-49.35,6.54,54.54,29.14,72.72c0,0-35.68-38.44-56.49-30.12S114,432.73,114,432.73s-36.27-11.43-32.11-2.6,15.46,10.39,15.46,10.39l-41,2.08H199l-32.11-3.12s33.3-16.62,24.38-23.38-28.54,7.79-28.54,7.79,33.89-37.4,27.35-51.42-35.68,25.45-35.68,25.45,23.79-50.38,19-59.22S152.62,369.35,152.62,369.35Z",
    style: {
      fill: "#929292"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.62,369.35s-14.87-35.84-23.19-34.28,14.27,57.14,14.27,57.14-26.16-49.35-44-49.35,6.54,54.54,29.14,72.72c0,0-35.68-38.44-56.49-30.12S114,432.73,114,432.73s-36.27-11.43-32.11-2.6,15.46,10.39,15.46,10.39l-41,2.08H199l-32.11-3.12s33.3-16.62,24.38-23.38-28.54,7.79-28.54,7.79,33.89-37.4,27.35-51.42-35.68,25.45-35.68,25.45,23.79-50.38,19-59.22S152.62,369.35,152.62,369.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.38,371.24c-13.08,38.65-13.08,66-13.08,66s15.46.6,31.51-11.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.84,392.05a232.21,232.21,0,0,0-10.71-33.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.19,369.46l33.29,49.35s22.6-19,30.33-29.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.89,430.7s-35.08-16.65-49.35-26.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Page--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "170.86 63 162.71 50 90.95 50 90.95 63 90.95 67.68 90.95 284 386.31 284 386.31 63 170.86 63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.14,
    y: 68.96,
    width: 291.22,
    height: 210.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.03,
    y: 67.16,
    width: 6.76,
    height: 213.72,
    style: {
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.03,
    y: 196.38,
    width: 6.76,
    height: 82.77,
    style: {
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.99,
    y: 66.12,
    width: 292.76,
    height: 11.44,
    style: {
      fill: "#929292",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.14,
    y: 68.96,
    width: 291.22,
    height: 210.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.87,88.59H224.5a1.81,1.81,0,0,1-1.8-1.8h0a1.81,1.81,0,0,1,1.8-1.8h20.37a1.8,1.8,0,0,1,1.8,1.8h0A1.8,1.8,0,0,1,244.87,88.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.62,88.59H265.25a1.8,1.8,0,0,1-1.8-1.8h0a1.8,1.8,0,0,1,1.8-1.8h20.37a1.81,1.81,0,0,1,1.8,1.8h0A1.81,1.81,0,0,1,285.62,88.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326.37,88.59H306a1.8,1.8,0,0,1-1.79-1.8h0A1.8,1.8,0,0,1,306,85h20.38a1.81,1.81,0,0,1,1.8,1.8h0A1.81,1.81,0,0,1,326.37,88.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M367.11,88.59H346.74a1.81,1.81,0,0,1-1.8-1.8h0a1.81,1.81,0,0,1,1.8-1.8h20.37a1.8,1.8,0,0,1,1.8,1.8h0A1.8,1.8,0,0,1,367.11,88.59Z"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 219.44,
    y1: 166.49,
    x2: 231.39,
    y2: 166.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.01,
    y1: 166.49,
    x2: 212.24,
    y2: 166.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 166.49,
    x2: 144.53,
    y2: 166.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.26,
    y1: 173.92,
    x2: 231.39,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.89,
    y1: 173.92,
    x2: 173.34,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 173.92,
    x2: 145.25,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.84,
    y1: 181.36,
    x2: 231.39,
    y2: 181.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 181.36,
    x2: 121.48,
    y2: 181.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.48,
    y1: 188.8,
    x2: 231.39,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.93,
    y1: 188.8,
    x2: 197.83,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 188.8,
    x2: 151.01,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.25,
    y1: 196.23,
    x2: 231.39,
    y2: 196.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 196.23,
    x2: 137.33,
    y2: 196.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.16,
    y1: 166.49,
    x2: 374.35,
    y2: 166.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.35,
    y1: 166.49,
    x2: 354.81,
    y2: 166.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 166.49,
    x2: 285.73,
    y2: 166.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.21,
    y1: 173.92,
    x2: 374.35,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.29,
    y1: 173.92,
    x2: 315.13,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 173.92,
    x2: 286.47,
    y2: 173.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.77,
    y1: 181.36,
    x2: 374.35,
    y2: 181.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 181.36,
    x2: 262.22,
    y2: 181.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.93,
    y1: 188.8,
    x2: 374.35,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.43,
    y1: 188.8,
    x2: 340.11,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 188.8,
    x2: 292.35,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.47,
    y1: 196.23,
    x2: 374.35,
    y2: 196.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 196.23,
    x2: 278.38,
    y2: 196.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.44,
    y1: 203.35,
    x2: 231.39,
    y2: 203.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.01,
    y1: 203.35,
    x2: 212.24,
    y2: 203.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 203.35,
    x2: 144.53,
    y2: 203.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.26,
    y1: 210.79,
    x2: 231.39,
    y2: 210.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.89,
    y1: 210.79,
    x2: 173.34,
    y2: 210.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 210.79,
    x2: 145.25,
    y2: 210.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.84,
    y1: 218.22,
    x2: 231.39,
    y2: 218.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 218.22,
    x2: 121.48,
    y2: 218.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.48,
    y1: 225.66,
    x2: 231.39,
    y2: 225.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.93,
    y1: 225.66,
    x2: 197.83,
    y2: 225.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 225.66,
    x2: 151.01,
    y2: 225.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.25,
    y1: 233.1,
    x2: 231.39,
    y2: 233.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.75,
    y1: 233.1,
    x2: 137.33,
    y2: 233.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.16,
    y1: 203.35,
    x2: 374.35,
    y2: 203.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.35,
    y1: 203.35,
    x2: 354.81,
    y2: 203.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 203.35,
    x2: 285.73,
    y2: 203.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.21,
    y1: 210.79,
    x2: 374.35,
    y2: 210.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.29,
    y1: 210.79,
    x2: 315.13,
    y2: 210.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 210.79,
    x2: 286.47,
    y2: 210.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.77,
    y1: 218.22,
    x2: 374.35,
    y2: 218.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 218.22,
    x2: 262.22,
    y2: 218.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.93,
    y1: 225.66,
    x2: 374.35,
    y2: 225.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.43,
    y1: 225.66,
    x2: 340.11,
    y2: 225.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 225.66,
    x2: 292.35,
    y2: 225.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.47,
    y1: 233.1,
    x2: 374.35,
    y2: 233.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.13,
    y1: 233.1,
    x2: 278.38,
    y2: 233.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35,159H103.16V103H374.35Z",
    style: {
      fill: "#929292"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35,159H103.16V103H374.35Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84,159H103.16V103H221.21l10.63,8.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.21 103.04 221.21 111.33 231.84 111.33 221.21 103.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.55,
    y1: 119.26,
    x2: 214.32,
    y2: 119.26,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.35,
    y1: 119.26,
    x2: 200.27,
    y2: 119.26,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.68,
    y1: 119.26,
    x2: 150.6,
    y2: 119.26,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.55,
    y1: 124.05,
    x2: 214.32,
    y2: 124.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.47,
    y1: 124.05,
    x2: 171.74,
    y2: 124.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.68,
    y1: 124.05,
    x2: 151.13,
    y2: 124.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.56,
    y1: 128.84,
    x2: 214.32,
    y2: 128.84,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.68,
    y1: 128.84,
    x2: 133.69,
    y2: 128.84,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.04,
    y1: 133.64,
    x2: 214.32,
    y2: 133.64,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.17,
    y1: 133.64,
    x2: 189.7,
    y2: 133.64,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.68,
    y1: 133.64,
    x2: 155.35,
    y2: 133.64,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.13,
    y1: 138.43,
    x2: 214.32,
    y2: 138.43,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.68,
    y1: 138.43,
    x2: 145.31,
    y2: 138.43,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.58,265.41H183a2.51,2.51,0,0,1-2.51-2.51V243.8a2.51,2.51,0,0,1,2.51-2.51h58.59a2.51,2.51,0,0,1,2.51,2.51v19.1A2.52,2.52,0,0,1,241.58,265.41Z",
    style: {
      fill: "#929292"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.14,254.67h-3.42l-.48,1.28a.72.72,0,0,1-.7.53.76.76,0,0,1-.51-.2.6.6,0,0,1-.23-.48.74.74,0,0,1,.06-.28l2.35-5.88a1.67,1.67,0,0,1,.51-.8,1.19,1.19,0,0,1,.71-.2,1.16,1.16,0,0,1,.7.2,1.6,1.6,0,0,1,.52.8l2.35,5.88a.72.72,0,0,1,.05.28.59.59,0,0,1-.22.48.77.77,0,0,1-.52.2.74.74,0,0,1-.41-.13.75.75,0,0,1-.28-.4Zm-1.71-4.57-1.32,3.53h2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.52,255a1.29,1.29,0,0,0,1.07.49,1.83,1.83,0,0,0,1.07-.28.51.51,0,0,1,.28-.09.37.37,0,0,1,.29.13.45.45,0,0,1,.12.31.55.55,0,0,1-.22.43,1.72,1.72,0,0,1-.65.34,3.44,3.44,0,0,1-1,.14,2.55,2.55,0,0,1-1.93-.78,2.71,2.71,0,0,1-.75-2,2.93,2.93,0,0,1,.33-1.38,2.49,2.49,0,0,1,1-1,2.65,2.65,0,0,1,1.41-.37,2.49,2.49,0,0,1,1.52.43.49.49,0,0,1,.24.41.45.45,0,0,1-.12.31.42.42,0,0,1-.31.13.55.55,0,0,1-.25-.07,2.11,2.11,0,0,0-.94-.24,1.32,1.32,0,0,0-1.09.48,1.93,1.93,0,0,0-.4,1.29A2,2,0,0,0,204.52,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.77,255a1.29,1.29,0,0,0,1.07.49,1.88,1.88,0,0,0,1.08-.28.48.48,0,0,1,.27-.09.36.36,0,0,1,.29.13.45.45,0,0,1,.12.31.53.53,0,0,1-.22.43,1.65,1.65,0,0,1-.65.34,3.35,3.35,0,0,1-1,.14,2.55,2.55,0,0,1-1.93-.78,2.71,2.71,0,0,1-.75-2,2.82,2.82,0,0,1,.34-1.38,2.54,2.54,0,0,1,.95-1,2.68,2.68,0,0,1,1.41-.37,2.54,2.54,0,0,1,1.53.43.49.49,0,0,1,.24.41.46.46,0,0,1-.13.31.4.4,0,0,1-.31.13.59.59,0,0,1-.25-.07,2.08,2.08,0,0,0-.94-.24,1.32,1.32,0,0,0-1.09.48,2,2,0,0,0-.39,1.29A2,2,0,0,0,209.77,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.59,252.36a2.47,2.47,0,0,1,.92-1,2.67,2.67,0,0,1,1.42-.38,2.73,2.73,0,0,1,1.1.21,2,2,0,0,1,.77.57,2.5,2.5,0,0,1,.44.82,3.1,3.1,0,0,1,.16,1,.51.51,0,0,1-.1.34.32.32,0,0,1-.29.13h-3.38a1.4,1.4,0,0,0,1.55,1.51,2.51,2.51,0,0,0,1.42-.54.32.32,0,0,1,.21-.08.38.38,0,0,1,.29.15.58.58,0,0,1,.13.34.48.48,0,0,1-.17.37,3,3,0,0,1-2,.71,2.8,2.8,0,0,1-2-.74,2.73,2.73,0,0,1-.77-2.06A3,3,0,0,1,213.59,252.36Zm3.66.94a1.81,1.81,0,0,0-.35-1,1.29,1.29,0,0,0-1.87,0,1.71,1.71,0,0,0-.39,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.64,258.28a.72.72,0,0,1-.19-.53v-5.91a.8.8,0,0,1,.2-.56.63.63,0,0,1,.48-.21.69.69,0,0,1,.48.17.67.67,0,0,1,.18.5v.19a1.87,1.87,0,0,1,1.77-.93,2.12,2.12,0,0,1,1.25.37,2.33,2.33,0,0,1,.8,1,3.56,3.56,0,0,1,.27,1.42,2.91,2.91,0,0,1-.65,2,2.23,2.23,0,0,1-1.75.73,1.84,1.84,0,0,1-1.69-.86v2.1a.69.69,0,0,1-.19.53.64.64,0,0,1-.49.19A.61.61,0,0,1,219.64,258.28Zm3.09-2.79a1,1,0,0,0,.39-.28,1.5,1.5,0,0,0,.25-.41,2.75,2.75,0,0,0,.14-.49,3.4,3.4,0,0,0,0-1,2.22,2.22,0,0,0-.13-.49,1.67,1.67,0,0,0-.24-.44,1.1,1.1,0,0,0-.39-.31,1.12,1.12,0,0,0-.53-.12,1.25,1.25,0,0,0-1.1.47,2.48,2.48,0,0,0-.32,1.39,2.82,2.82,0,0,0,.13.91,1.43,1.43,0,0,0,.47.66,1.23,1.23,0,0,0,.8.25A1.29,1.29,0,0,0,222.73,255.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.84,256.05a1.84,1.84,0,0,1-.41-1.28V252h-.52a.52.52,0,0,1-.36-.12.49.49,0,0,1-.12-.34.45.45,0,0,1,.11-.31.48.48,0,0,1,.35-.13h.57l.16-1.32a.78.78,0,0,1,.2-.48.59.59,0,0,1,.46-.18.47.47,0,0,1,.37.15.77.77,0,0,1,.13.47v1.36h.86a.46.46,0,0,1,.34.13.47.47,0,0,1,.12.34.44.44,0,0,1-.12.32.45.45,0,0,1-.34.11h-.86v2.44a1.72,1.72,0,0,0,.13.77.45.45,0,0,0,.45.25h.06l.38,0h0a.44.44,0,0,1,.35.15.54.54,0,0,1,.08.58.37.37,0,0,1-.13.15l-.19.1a1.33,1.33,0,0,1-.26.05l-.29,0H228A1.48,1.48,0,0,1,226.84,256.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,265.41H106a2.51,2.51,0,0,1-2.51-2.51V243.8a2.51,2.51,0,0,1,2.51-2.51h58.58a2.51,2.51,0,0,1,2.51,2.51v19.1A2.51,2.51,0,0,1,164.61,265.41Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.64,256.26a.62.62,0,0,1-.21-.49v-6.12a.94.94,0,0,1,.24-.68.72.72,0,0,1,.57-.25,1,1,0,0,1,.5.15,1.08,1.08,0,0,1,.43.39l3.52,4.88V249.4a.62.62,0,0,1,.21-.49.72.72,0,0,1,1,0,.64.64,0,0,1,.21.5v6a1.18,1.18,0,0,1-.23.75.69.69,0,0,1-.59.29.94.94,0,0,1-.49-.16,1.61,1.61,0,0,1-.45-.41l-3.5-4.85v4.75a.63.63,0,0,1-.2.49.74.74,0,0,1-.49.18A.72.72,0,0,1,109.64,256.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.93,256.28a2.29,2.29,0,0,1-.88-.62,2.83,2.83,0,0,1-.5-.88,3.12,3.12,0,0,1-.17-1,3.32,3.32,0,0,1,.11-.83,2.77,2.77,0,0,1,.33-.75,2.63,2.63,0,0,1,.54-.61,2.34,2.34,0,0,1,.8-.42,3.33,3.33,0,0,1,1-.15,3.24,3.24,0,0,1,1,.15,2.35,2.35,0,0,1,.79.4,2.45,2.45,0,0,1,.56.6,2.73,2.73,0,0,1,.34.76,3.35,3.35,0,0,1,.11.85,3.18,3.18,0,0,1-.11.82,2.31,2.31,0,0,1-.32.74,2.5,2.5,0,0,1-.55.62,2.46,2.46,0,0,1-.79.41,3.15,3.15,0,0,1-1,.16A3.33,3.33,0,0,1,118.93,256.28Zm2.34-1.17a2.09,2.09,0,0,0,.39-1.35,2.14,2.14,0,0,0-.39-1.36,1.32,1.32,0,0,0-1.08-.49,1.3,1.3,0,0,0-1.08.49,2.12,2.12,0,0,0-.38,1.36,2.09,2.09,0,0,0,.38,1.35,1.45,1.45,0,0,0,2.16,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.14,254.67h-3.41l-.49,1.28a.75.75,0,0,1-.28.4.74.74,0,0,1-.41.13.77.77,0,0,1-.52-.2.59.59,0,0,1-.22-.48,1,1,0,0,1,0-.28l2.35-5.88a1.6,1.6,0,0,1,.52-.8,1.16,1.16,0,0,1,.7-.2,1.19,1.19,0,0,1,.71.2,1.6,1.6,0,0,1,.51.8l2.36,5.88a1,1,0,0,1,.05.28.6.6,0,0,1-.23.48.76.76,0,0,1-.51.2.8.8,0,0,1-.42-.13.87.87,0,0,1-.28-.4Zm-1.71-4.57-1.32,3.53h2.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.53,255a1.26,1.26,0,0,0,1.07.49,1.87,1.87,0,0,0,1.07-.28.48.48,0,0,1,.27-.09.36.36,0,0,1,.29.13.45.45,0,0,1,.12.31.54.54,0,0,1-.21.43,1.7,1.7,0,0,1-.66.34,3.33,3.33,0,0,1-1,.14,2.58,2.58,0,0,1-1.94-.78,2.71,2.71,0,0,1-.75-2,2.82,2.82,0,0,1,.34-1.38,2.54,2.54,0,0,1,.95-1,2.7,2.7,0,0,1,1.41-.37,2.5,2.5,0,0,1,1.53.43.49.49,0,0,1,.24.41.42.42,0,0,1-.13.31.38.38,0,0,1-.3.13.63.63,0,0,1-.26-.07,2.08,2.08,0,0,0-.94-.24,1.33,1.33,0,0,0-1.09.48,2,2,0,0,0-.39,1.29A2,2,0,0,0,136.53,255Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,255a1.28,1.28,0,0,0,1.07.49,1.83,1.83,0,0,0,1.07-.28.49.49,0,0,1,.28-.09.37.37,0,0,1,.29.13.45.45,0,0,1,.12.31.55.55,0,0,1-.22.43,1.72,1.72,0,0,1-.65.34,3.44,3.44,0,0,1-1,.14,2.55,2.55,0,0,1-1.93-.78,2.71,2.71,0,0,1-.75-2,2.93,2.93,0,0,1,.33-1.38,2.49,2.49,0,0,1,1-1,2.65,2.65,0,0,1,1.41-.37,2.49,2.49,0,0,1,1.52.43.49.49,0,0,1,.24.41.45.45,0,0,1-.12.31.42.42,0,0,1-.31.13.55.55,0,0,1-.25-.07,2.12,2.12,0,0,0-.95-.24,1.31,1.31,0,0,0-1.08.48,1.93,1.93,0,0,0-.4,1.29A2,2,0,0,0,141.78,255Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,252.36a2.4,2.4,0,0,1,.92-1,2.64,2.64,0,0,1,1.42-.38,2.73,2.73,0,0,1,1.1.21,2,2,0,0,1,.77.57,2.7,2.7,0,0,1,.44.82,3.1,3.1,0,0,1,.15,1,.57.57,0,0,1-.09.34.34.34,0,0,1-.29.13h-3.39a1.4,1.4,0,0,0,1.55,1.51,2.46,2.46,0,0,0,1.42-.54.34.34,0,0,1,.5.07.52.52,0,0,1,.13.34.45.45,0,0,1-.17.37,3,3,0,0,1-2,.71,2.82,2.82,0,0,1-2-.74,2.72,2.72,0,0,1-.76-2.06A2.91,2.91,0,0,1,145.6,252.36Zm3.66.94a1.81,1.81,0,0,0-.36-1,1.12,1.12,0,0,0-.93-.39,1.14,1.14,0,0,0-.94.41,1.77,1.77,0,0,0-.38,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,258.28a.76.76,0,0,1-.19-.53v-5.91a.8.8,0,0,1,.2-.56.67.67,0,0,1,.49-.21.69.69,0,0,1,.48.17.67.67,0,0,1,.18.5v.19a1.85,1.85,0,0,1,1.77-.93,2.09,2.09,0,0,1,1.24.37,2.35,2.35,0,0,1,.81,1,3.56,3.56,0,0,1,.27,1.42,2.86,2.86,0,0,1-.66,2,2.19,2.19,0,0,1-1.74.73,1.83,1.83,0,0,1-1.69-.86v2.1a.69.69,0,0,1-.19.53.66.66,0,0,1-.49.19A.65.65,0,0,1,151.64,258.28Zm3.1-2.79a1,1,0,0,0,.38-.28,1.29,1.29,0,0,0,.25-.41,1.71,1.71,0,0,0,.14-.49,2.89,2.89,0,0,0,.05-.53,4.38,4.38,0,0,0,0-.51,2.22,2.22,0,0,0-.13-.49,1.69,1.69,0,0,0-.25-.44,1.06,1.06,0,0,0-.38-.31,1.19,1.19,0,0,0-.54-.12,1.24,1.24,0,0,0-1.09.47,2.4,2.4,0,0,0-.33,1.39,2.81,2.81,0,0,0,.14.91,1.42,1.42,0,0,0,.46.66,1.28,1.28,0,0,0,.81.25A1.32,1.32,0,0,0,154.74,255.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.84,256.05a1.84,1.84,0,0,1-.41-1.28V252h-.52a.48.48,0,0,1-.35-.12.45.45,0,0,1-.13-.34.41.41,0,0,1,.12-.31.47.47,0,0,1,.35-.13h.56l.16-1.32a.84.84,0,0,1,.2-.48.61.61,0,0,1,.47-.18.46.46,0,0,1,.36.15.71.71,0,0,1,.13.47v1.36h.87a.46.46,0,0,1,.34.13.47.47,0,0,1,.12.34.44.44,0,0,1-.12.32.48.48,0,0,1-.35.11h-.86v2.44a1.88,1.88,0,0,0,.13.77.47.47,0,0,0,.46.25h.06l.38,0h0a.43.43,0,0,1,.35.15.51.51,0,0,1,.13.35.56.56,0,0,1,0,.23.4.4,0,0,1-.14.15l-.19.1a1.2,1.2,0,0,1-.26.05l-.28,0H160A1.51,1.51,0,0,1,158.84,256.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17,135.46a4.74,4.74,0,0,1-2.05-2.06,7,7,0,0,1-.73-3.33,7.18,7.18,0,0,1,.37-2.37,5.67,5.67,0,0,1,1.1-1.93,4.89,4.89,0,0,1,1.88-1.31,6.83,6.83,0,0,1,2.64-.48,8,8,0,0,1,3.47.71.92.92,0,0,1,.38.35.87.87,0,0,1,.13.44,1,1,0,0,1-.23.64.71.71,0,0,1-.58.29.6.6,0,0,1-.27-.06,9.76,9.76,0,0,0-2.82-.52,4.24,4.24,0,0,0-1.66.3,2.7,2.7,0,0,0-1.14.87,4,4,0,0,0-.63,1.33,6.91,6.91,0,0,0-.2,1.73c0,2.82,1.19,4.23,3.55,4.23a9,9,0,0,0,2.1-.25v-2.75h-1.69a.75.75,0,0,1-.57-.23.87.87,0,0,1-.21-.59.9.9,0,0,1,.2-.57.66.66,0,0,1,.55-.26h3.12c.59,0,.88.36.88,1.09v3.38a1.83,1.83,0,0,1-.25,1.08,1.51,1.51,0,0,1-.86.48,16.55,16.55,0,0,1-3.38.47A6.56,6.56,0,0,1,256.17,135.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.71,129.79a3.56,3.56,0,0,1,1.38-1.48,4,4,0,0,1,2.13-.56,4.1,4.1,0,0,1,1.66.31,2.83,2.83,0,0,1,1.16.86,3.84,3.84,0,0,1,.66,1.23,5,5,0,0,1,.24,1.48.81.81,0,0,1-.15.51.49.49,0,0,1-.43.19h-5.1a2.11,2.11,0,0,0,2.33,2.27,3.75,3.75,0,0,0,2.14-.81.53.53,0,0,1,.31-.11.58.58,0,0,1,.45.22.75.75,0,0,1,.19.51.71.71,0,0,1-.26.55,4.5,4.5,0,0,1-3,1.07,4.23,4.23,0,0,1-3.06-1.11,4.1,4.1,0,0,1-1.15-3.1A4.43,4.43,0,0,1,265.71,129.79Zm5.5,1.41a2.72,2.72,0,0,0-.53-1.53,1.93,1.93,0,0,0-2.81,0,2.57,2.57,0,0,0-.59,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.8,135.64a1.13,1.13,0,0,1-.28-.82v-5.95a.94.94,0,0,1,.29-.75,1,1,0,0,1,.73-.27,1,1,0,0,1,.72.26,1,1,0,0,1,.28.74v.28a2.43,2.43,0,0,1,1-1,3.52,3.52,0,0,1,1.62-.35,3,3,0,0,1,1.09.19,3,3,0,0,1,.92.55,2.55,2.55,0,0,1,.63,1,3.68,3.68,0,0,1,.24,1.37v4a1.14,1.14,0,0,1-.29.82,1,1,0,0,1-.75.29.9.9,0,0,1-.7-.29,1.14,1.14,0,0,1-.29-.82v-4a1.71,1.71,0,0,0-.43-1.27,1.45,1.45,0,0,0-1.1-.44,1.84,1.84,0,0,0-1.39.63,2.37,2.37,0,0,0-.59,1.66v3.41a1.14,1.14,0,0,1-.29.82,1.05,1.05,0,0,1-1.45,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.18,129.79a3.65,3.65,0,0,1,1.39-1.48,4,4,0,0,1,2.13-.56,4.13,4.13,0,0,1,1.66.31,2.9,2.9,0,0,1,1.16.86,3.84,3.84,0,0,1,.66,1.23,5,5,0,0,1,.24,1.48.81.81,0,0,1-.15.51.5.5,0,0,1-.43.19h-5.1a2.1,2.1,0,0,0,2.33,2.27,3.75,3.75,0,0,0,2.14-.81.51.51,0,0,1,.31-.11.54.54,0,0,1,.44.22.76.76,0,0,1,.2.51.71.71,0,0,1-.26.55,4.5,4.5,0,0,1-3,1.07,4.2,4.2,0,0,1-3.06-1.11,4.1,4.1,0,0,1-1.15-3.1A4.42,4.42,0,0,1,284.18,129.79Zm5.51,1.41a2.72,2.72,0,0,0-.53-1.53,1.95,1.95,0,0,0-2.82,0,2.63,2.63,0,0,0-.58,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.29,135.65a1.11,1.11,0,0,1-.29-.82v-6a.85.85,0,0,1,.31-.71,1.08,1.08,0,0,1,.72-.26,1.06,1.06,0,0,1,.71.25.78.78,0,0,1,.29.67l0,.83a2.51,2.51,0,0,1,.83-1.24,2,2,0,0,1,1.36-.52.67.67,0,0,1,.57.25.88.88,0,0,1,.21.6,1,1,0,0,1-.19.6.58.58,0,0,1-.5.25,4.13,4.13,0,0,0-.84.08,2.36,2.36,0,0,0-.71.27,1.31,1.31,0,0,0-.52.59,2.29,2.29,0,0,0-.19,1v3.4a1.07,1.07,0,0,1-.28.8,1,1,0,0,1-.74.28A1,1,0,0,1,293.29,135.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.53,135.41a2,2,0,0,1-.79-1.69,3.1,3.1,0,0,1,.1-.85,2,2,0,0,1,.28-.63,1.57,1.57,0,0,1,.52-.46,4,4,0,0,1,.7-.3,4.62,4.62,0,0,1,.94-.18c.37,0,.76-.07,1.14-.08s.86,0,1.41,0v-.62a1.48,1.48,0,0,0-.36-1.11,1.45,1.45,0,0,0-1.07-.35h-.31l-.32,0-.28.05a1.33,1.33,0,0,0-.29.07l-.26.07-.26.08-.22.08-.21.08-.18.07a.5.5,0,0,1-.23,0,.61.61,0,0,1-.47-.23.79.79,0,0,1-.2-.54.58.58,0,0,1,.35-.56,6.89,6.89,0,0,1,3-.63,4.61,4.61,0,0,1,1.33.17,2.86,2.86,0,0,1,1,.52,2.22,2.22,0,0,1,.7,1,3.66,3.66,0,0,1,.25,1.43v4.09a1,1,0,0,1-.28.75,1,1,0,0,1-.68.26.93.93,0,0,1-.68-.26,1,1,0,0,1-.29-.75v-.27a2.24,2.24,0,0,1-.83,1,2.75,2.75,0,0,1-1.51.38A3.15,3.15,0,0,1,299.53,135.41Zm3.67-1.29a2.22,2.22,0,0,0,.62-1.61v-.23c-.54,0-1,0-1.28,0s-.61,0-.89.09a1.52,1.52,0,0,0-.63.22,1,1,0,0,0-.31.39,1.35,1.35,0,0,0-.12.61,1.07,1.07,0,0,0,.33.85,1.24,1.24,0,0,0,.87.3A1.92,1.92,0,0,0,303.2,134.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,135.64a1.18,1.18,0,0,1-.27-.83v-9.36a1.16,1.16,0,0,1,.28-.83,1,1,0,0,1,.72-.3,1,1,0,0,1,.74.3,1.16,1.16,0,0,1,.29.83v9.36a1.13,1.13,0,0,1-.3.83,1,1,0,0,1-.74.29A.94.94,0,0,1,308.25,135.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.74,135.61a1.17,1.17,0,0,1-.35-.88v-8.59h-2.62a.85.85,0,0,1-.66-.27.93.93,0,0,1-.24-.64,1,1,0,0,1,.25-.65.83.83,0,0,1,.65-.27h7.56a.84.84,0,0,1,.64.27,1,1,0,0,1,.24.65.94.94,0,0,1-.24.64.82.82,0,0,1-.64.27h-2.62v8.59a1.17,1.17,0,0,1-.35.88,1.12,1.12,0,0,1-.81.33A1.1,1.1,0,0,1,319.74,135.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5,129.79a3.7,3.7,0,0,1,1.38-1.48,4,4,0,0,1,2.13-.56,4.1,4.1,0,0,1,1.66.31,2.83,2.83,0,0,1,1.16.86,4.07,4.07,0,0,1,.67,1.23,5,5,0,0,1,.23,1.48.81.81,0,0,1-.15.51.49.49,0,0,1-.43.19h-5.09a2.1,2.1,0,0,0,2.33,2.27,3.75,3.75,0,0,0,2.13-.81.53.53,0,0,1,.31-.11.58.58,0,0,1,.45.22.75.75,0,0,1,.19.51.68.68,0,0,1-.26.55,4.5,4.5,0,0,1-3,1.07,4.23,4.23,0,0,1-3.06-1.11,4.14,4.14,0,0,1-1.15-3.1A4.43,4.43,0,0,1,326.5,129.79Zm5.5,1.41a2.72,2.72,0,0,0-.53-1.53,1.93,1.93,0,0,0-2.81,0,2.64,2.64,0,0,0-.59,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,135.65a1.1,1.1,0,0,1-.28-.82v-6a.87.87,0,0,1,.3-.71,1.08,1.08,0,0,1,.72-.26,1.06,1.06,0,0,1,.71.25.79.79,0,0,1,.3.67l0,.83a2.58,2.58,0,0,1,.83-1.24,2,2,0,0,1,1.37-.52.7.7,0,0,1,.57.25.92.92,0,0,1,.2.6,1,1,0,0,1-.19.6.58.58,0,0,1-.5.25,4.28,4.28,0,0,0-.84.08,2.31,2.31,0,0,0-.7.27,1.33,1.33,0,0,0-.53.59,2.3,2.3,0,0,0-.18,1v3.4a1.07,1.07,0,0,1-.29.8,1,1,0,0,1-.74.28A1,1,0,0,1,335.6,135.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.84,135.64a1.15,1.15,0,0,1-.28-.82v-5.89a1.13,1.13,0,0,1,.28-.8,1,1,0,0,1,.74-.28,1.08,1.08,0,0,1,.72.26.89.89,0,0,1,.29.7v.4a2.67,2.67,0,0,1,2.59-1.46,2.85,2.85,0,0,1,1.69.47,2.33,2.33,0,0,1,.94,1.29,2.82,2.82,0,0,1,2.84-1.76,2.94,2.94,0,0,1,2.13.77,3,3,0,0,1,.8,2.29v4a1.1,1.1,0,0,1-.28.82,1,1,0,0,1-.74.29.94.94,0,0,1-.72-.29,1.15,1.15,0,0,1-.28-.82v-4a1.82,1.82,0,0,0-.4-1.28,1.44,1.44,0,0,0-1.11-.43,1.79,1.79,0,0,0-1.42.63,2.5,2.5,0,0,0-.55,1.73v3.34a1.18,1.18,0,0,1-.28.82,1,1,0,0,1-.74.29.94.94,0,0,1-.72-.29,1.13,1.13,0,0,1-.28-.82v-3.95a1.88,1.88,0,0,0-.4-1.31,1.45,1.45,0,0,0-1.12-.44,1.83,1.83,0,0,0-1.42.58,2.25,2.25,0,0,0-.53,1.58v3.54a1.11,1.11,0,0,1-.29.82,1,1,0,0,1-.75.29A.94.94,0,0,1,341.84,135.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,134.58a.69.69,0,0,1,.18-.47.6.6,0,0,1,.46-.2.84.84,0,0,1,.42.12l.57.31a4.28,4.28,0,0,0,.69.24,3.68,3.68,0,0,0,1.78,0,1.38,1.38,0,0,0,.63-.34.82.82,0,0,0,.26-.63c0-.46-.37-.78-1.12-1l-1.25-.33q-.57-.15-.93-.27a4.47,4.47,0,0,1-.72-.31,1.93,1.93,0,0,1-.55-.42,1.73,1.73,0,0,1-.32-.57,2.45,2.45,0,0,1-.12-.8,1.93,1.93,0,0,1,.89-1.7,4.17,4.17,0,0,1,2.33-.59,6,6,0,0,1,2.64.6.68.68,0,0,1,.43.65.63.63,0,0,1-.16.44.57.57,0,0,1-.44.18.76.76,0,0,1-.31-.07l-.18-.06-.24-.09-.25-.08a1.85,1.85,0,0,0-.32-.08l-.32-.07-.37-.05-.36,0a2.41,2.41,0,0,0-1.06.21.67.67,0,0,0-.43.63.68.68,0,0,0,.23.56,2.65,2.65,0,0,0,.91.33l1.24.32a4.26,4.26,0,0,1,1.9.88,2,2,0,0,1,.6,1.54,2.16,2.16,0,0,1-.91,1.88,3.89,3.89,0,0,1-2.35.66,5.22,5.22,0,0,1-3.16-.94A.62.62,0,0,1,356.4,134.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.37,247.67c.28-.55,2.09,1.29,2.09,1.29,1.47,1.47,12.45,12.45,14.42,12.45s37.32,11.82,37.32,11.82l27.95-7.6C318.6,272,310.26,284,310.26,284s-21.82,1.72-26,0-34.57-18.63-34.57-18.63-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74c-.49-.74-.73-.74-2.45-2.21a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79a8.64,8.64,0,0,1-1.11-1.67c-.44-1,.26-1.28.26-1.28S234.09,248.23,234.37,247.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.37,247.67c.28-.55,2.09,1.29,2.09,1.29,1.47,1.47,12.45,12.45,14.42,12.45s37.32,11.82,37.32,11.82l27.95-7.6C318.6,272,310.26,284,310.26,284s-21.82,1.72-26,0-34.57-18.63-34.57-18.63-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74c-.49-.74-.73-.74-2.45-2.21a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79a8.64,8.64,0,0,1-1.11-1.67c-.44-1,.26-1.28.26-1.28S234.09,248.23,234.37,247.67Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.37,247.67c.28-.55,2.09,1.29,2.09,1.29,1.47,1.47,12.45,12.45,14.42,12.45s37.32,11.82,37.32,11.82l27.95-7.6C318.6,272,310.26,284,310.26,284s-21.82,1.72-26,0-34.57-18.63-34.57-18.63-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74c-.49-.74-.73-.74-2.45-2.21a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79a8.64,8.64,0,0,1-1.11-1.67c-.44-1,.26-1.28.26-1.28S234.09,248.23,234.37,247.67Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,259.5a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79a8.64,8.64,0,0,1-1.11-1.67c-.44-1,.26-1.28.26-1.28s-.65-1.2-.37-1.76,2.09,1.29,2.09,1.29c1.47,1.47,12.45,12.45,14.42,12.45s37.32,11.82,37.32,11.82l13.68-3.72a121.31,121.31,0,0,0,10.65,10.82c-1.23,2.2-2.27,3.69-2.27,3.69s-21.82,1.72-26,0-34.57-18.63-34.57-18.63-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74C239.89,261,239.65,261,237.93,259.5Z",
    style: {
      fill: "#929292",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87,248.44a25.89,25.89,0,0,1,5.4,3.38,44.29,44.29,0,0,1,4,5.49S236.7,250.09,235.87,248.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.87,248.44a25.89,25.89,0,0,1,5.4,3.38,44.29,44.29,0,0,1,4,5.49S236.7,250.09,235.87,248.44Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.87,248.44a25.89,25.89,0,0,1,5.4,3.38,44.29,44.29,0,0,1,4,5.49S236.7,250.09,235.87,248.44Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,250.71c-.44-1,.26-1.28.26-1.28s-.65-1.2-.37-1.76,2.09,1.29,2.09,1.29c1.47,1.47,12.45,12.45,14.42,12.45,1,0,10.38,3,19.5,5.95l-3.53,7.48c-8.64-4.71-17.15-9.45-17.15-9.45s-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74c-.49-.74-.73-.74-2.45-2.21a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79A8.64,8.64,0,0,1,234.48,250.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.48,250.71c-.44-1,.26-1.28.26-1.28s-.65-1.2-.37-1.76,2.09,1.29,2.09,1.29c1.47,1.47,12.45,12.45,14.42,12.45,1,0,10.38,3,19.5,5.95l-3.53,7.48c-8.64-4.71-17.15-9.45-17.15-9.45s-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74c-.49-.74-.73-.74-2.45-2.21a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79A8.64,8.64,0,0,1,234.48,250.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,256.81s2.8,1.74,5.2,3.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.74,249.43a6.84,6.84,0,0,1,2.32,2.21,30.68,30.68,0,0,0,4.87,5.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,250.71c-.44-1,.26-1.28.26-1.28s-.65-1.2-.37-1.76,2.09,1.29,2.09,1.29c1.47,1.47,12.45,12.45,14.42,12.45,1,0,10.38,3,19.5,5.95l-3.53,7.48c-8.64-4.71-17.15-9.45-17.15-9.45s-3.69.05-5.65-.94a9.84,9.84,0,0,1-3.67-2.74c-.49-.74-.73-.74-2.45-2.21a1.52,1.52,0,0,1-.29-2.42l1,.09-3-4.79A8.64,8.64,0,0,1,234.48,250.71Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.33,227.79a28.53,28.53,0,0,1,2.7-8.49c2.15-4.18,8.62-5.12,9.3-4.31s.81,1.08,3.37.67,8.76,1.35,7.55,2.56-.41,1.62,2.56,2.7,2.83,4.18.94,5.26-1.08,1.88.4,3.64,1,3.5-.4,3.63-2.29-.53-.94,1.76.81,4.71-1.22,5-1.61,1.22-1.61,3.1-1.35,3-2.43,2.7-2.16.4-2.7,1.89-2.15,1.35-3.23.67-1.89-.27-2.16.54-.54,1.35-2.56.27-2.69-2.83-3.77-1.62a1.74,1.74,0,0,1-3-1.21,18.91,18.91,0,0,0-1.35-5.66C332,239.12,330.25,232.11,331.33,227.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.9,317.37s8.82,6.38,10.05,12.26,3.43,15.94,3.68,17.16,10.54,35.56,10.79,36.78S376,392.4,375.73,400s4.42,42.91,4.66,45.12-2,3.43-4.17,4.66-6.63,5.77-11.77,2.94c-4-2.18,9.32-10.05,9.32-14s-13-39.47-16.67-46.83S344.59,367.15,341.9,363a60.78,60.78,0,0,1-4.66-9.07s-.74,16.18,1.22,24.52,3.68,21.57,1,34.57-3.43,25.74-2.69,29.91-.49,4.42-2.95,5.15-7.13-.15-10.07,1.11-8.87,1-9.28-1,9.55-6,12.73-8.43,2.21-6.62,2.95-16.68-5.4-35.8-6.38-41.44-6.87-26.48-6.87-38.25.74-16.67.74-16.67,3.43-3.43,10.79-6.62A31.08,31.08,0,0,1,341.9,317.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.9,317.37s8.82,6.38,10.05,12.26,3.43,15.94,3.68,17.16,10.54,35.56,10.79,36.78S376,392.4,375.73,400s4.42,42.91,4.66,45.12-2,3.43-4.17,4.66-6.63,5.77-11.77,2.94c-4-2.18,9.32-10.05,9.32-14s-13-39.47-16.67-46.83S344.59,367.15,341.9,363a60.78,60.78,0,0,1-4.66-9.07s-.74,16.18,1.22,24.52,3.68,21.57,1,34.57-3.43,25.74-2.69,29.91-.49,4.42-2.95,5.15-7.13-.15-10.07,1.11-8.87,1-9.28-1,9.55-6,12.73-8.43,2.21-6.62,2.95-16.68-5.4-35.8-6.38-41.44-6.87-26.48-6.87-38.25.74-16.67.74-16.67,3.43-3.43,10.79-6.62A31.08,31.08,0,0,1,341.9,317.37Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.9,317.37s8.82,6.38,10.05,12.26,3.43,15.94,3.68,17.16,10.54,35.56,10.79,36.78S376,392.4,375.73,400s4.42,42.91,4.66,45.12-2,3.43-4.17,4.66-6.63,5.77-11.77,2.94c-4-2.18,9.32-10.05,9.32-14s-13-39.47-16.67-46.83S344.59,367.15,341.9,363a60.78,60.78,0,0,1-4.66-9.07s-.74,16.18,1.22,24.52,3.68,21.57,1,34.57-3.43,25.74-2.69,29.91-.49,4.42-2.95,5.15-7.13-.15-10.07,1.11-8.87,1-9.28-1,9.55-6,12.73-8.43,2.21-6.62,2.95-16.68-5.4-35.8-6.38-41.44-6.87-26.48-6.87-38.25.74-16.67.74-16.67,3.43-3.43,10.79-6.62A31.08,31.08,0,0,1,341.9,317.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.92,416.29c-1.1-11.92-5.37-30.05-6.17-34.68-1-5.64-6.87-26.48-6.87-38.25s.74-16.67.74-16.67,3.43-3.43,10.79-6.62a31.08,31.08,0,0,1,13.49-2.7s8.82,6.38,10.05,12.26,3.43,15.94,3.68,17.16,10.54,35.56,10.79,36.78S376,392.4,375.73,400c-.08,2.48.37,7.92,1,14.19a28.91,28.91,0,0,1-9.64,3.21c-3.78-10.53-8.12-21.72-10-25.49-3.68-7.35-12.51-24.76-15.2-28.93a60.78,60.78,0,0,1-4.66-9.07s-.74,16.18,1.22,24.52,3.68,21.57,1,34.57c-.21,1-.4,2-.59,3C337.3,416.57,334.55,417,329.92,416.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.24,
    y1: 353.91,
    x2: 329.64,
    y2: 343.36,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.61,314.92l1.23,3.68s-10.64,10.72-20,11.94-9,.32-9-2.14,8.59-5.88,16.19-9.8S341.4,314.18,343.61,314.92Z",
    style: {
      fill: "#929292",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,236.56c0-1.88-1.73-8.55,3.07-12.93s13.24-3.39,13.24-3.39c10,.68,15.91,12.14,13.89,20.22s-7.82,9-9.84,11.6c-1.1,1.38-.34,5,.59,8,8.6.39,7.95,7.22,9.54,12,2,5.88,4.66,24.52,5.39,28.69s6.13,11.28,6.13,13.73-10.79,6.37-20.1,11-9.17,4.89-10.89,2.43S311,300.94,311,298s-8.83-10.3-6.87-14.47c1.58-3.36,8.73-15.94,11.45-20.7l-.15-.53a72.64,72.64,0,0,0-3.91-8.76s-5.13.27-6.61.13-2.29-.54-2.56-1.88a6.77,6.77,0,0,1,.4-3.1s-.53.13-.8-.68.67-1.48.67-1.48c-.67-.27-.68-1.6-.68-1.6l1.25-1.26s-2.19-.62-2.4-2.29S303.56,238.43,303.56,236.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.56,236.56c0-1.88-1.73-8.55,3.07-12.93s13.24-3.39,13.24-3.39c10,.68,15.91,12.14,13.89,20.22s-7.82,9-9.84,11.6c-1.1,1.38-.34,5,.59,8,8.6.39,7.95,7.22,9.54,12,2,5.88,4.66,24.52,5.39,28.69s6.13,11.28,6.13,13.73-10.79,6.37-20.1,11-12.26,3.93-14,1.47-.49-26-.49-28.93-8.83-10.3-6.87-14.47c1.58-3.36,8.73-15.94,11.45-20.7l-.15-.53a72.64,72.64,0,0,0-3.91-8.76s-5.13.27-6.61.13-2.29-.54-2.56-1.88a6.77,6.77,0,0,1,.4-3.1s-.53.13-.8-.68.67-1.48.67-1.48c-.67-.27-.68-1.6-.68-1.6l1.25-1.26s-2.19-.62-2.4-2.29S303.56,238.43,303.56,236.56Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,236.56c0-1.88-1.73-8.55,3.07-12.93s13.24-3.39,13.24-3.39c10,.68,15.91,12.14,13.89,20.22s-7.82,9-9.84,11.6c-1.1,1.38-.34,5,.59,8,8.6.39,7.95,7.22,9.54,12,2,5.88,4.66,24.52,5.39,28.69s6.13,11.28,6.13,13.73-10.79,6.37-20.1,11-9.17,4.89-10.89,2.43S311,300.94,311,298s-8.83-10.3-6.87-14.47c1.58-3.36,8.73-15.94,11.45-20.7l-.15-.53a72.64,72.64,0,0,0-3.91-8.76s-5.13.27-6.61.13-2.29-.54-2.56-1.88a6.77,6.77,0,0,1,.4-3.1s-.53.13-.8-.68.67-1.48.67-1.48c-.67-.27-.68-1.6-.68-1.6l1.25-1.26s-2.19-.62-2.4-2.29S303.56,238.43,303.56,236.56Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,237c-.14.69,0,1.31.34,1.38s.71-.44.85-1.14,0-1.31-.34-1.37S306.14,236.35,306,237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.82,234.53s-.4-2.15-3.1-1.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.62,246.53s1.75.54,2.29-.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.13,283.53c.64-1.36,2.2-4.23,4-7.48l.66.37A36.25,36.25,0,0,0,336,280.15c1.5,7.74,3,17.65,3.47,20.55.74,4.17,6.13,11.28,6.13,13.73s-5.8,7.07-15.12,11.72-14.15,4.2-15.87,1.74S311,300.94,311,298,302.17,287.7,304.13,283.53Z",
    style: {
      fill: "#929292",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.33,284.51s-8.58-.24-12.5-1.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.52,286.72s-7.72,1.23-9.93.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.36,220.55a24.14,24.14,0,0,1,6.51-.31c10,.68,15.91,12.14,13.89,20.22-1.73,6.92-6.22,8.61-8.75,10.56-2-.82-4.19-2-4.87-3.41a19.08,19.08,0,0,1-1.61-4.45s-1.35.94-1.76-1.35-2.88-3.62-4.3-6.45.54-5.92,2.37-8.35C316.25,225.12,317.4,221.68,313.36,220.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.66,219.06a7.09,7.09,0,0,0-7.34-.76c-4.67,2.12,2.12,5.09,4.67,9.12s3.82,10.19,5.09,6.58,2.07-7.73.45-11.31A9.06,9.06,0,0,0,314.66,219.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.25,242.45s3.1-5.19,6.21-3.58-.74,6.84-3.11,8.15-3.25-2-3.25-2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.25,242.45s3.1-5.19,6.21-3.58-.74,6.84-3.11,8.15-3.25-2-3.25-2",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.25,242.45s3.1-5.19,6.21-3.58-.74,6.84-3.11,8.15-3.25-2-3.25-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.62,270.05s5.39-8.58,11.77-6.13,27.22,29.18,27.95,33.34,6.38,38.26,6.38,38.26,1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-12.5-28.68-13-31.38a15.21,15.21,0,0,0-1.47-4.42s-22.56-18.63-24.77-22.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.62,270.05s5.39-8.58,11.77-6.13,27.22,29.18,27.95,33.34,6.38,38.26,6.38,38.26,1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-12.5-28.68-13-31.38a15.21,15.21,0,0,0-1.47-4.42s-22.56-18.63-24.77-22.06",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.62,270.05s5.39-8.58,11.77-6.13,27.22,29.18,27.95,33.34,6.38,38.26,6.38,38.26,1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-12.5-28.68-13-31.38a15.21,15.21,0,0,0-1.47-4.42s-22.56-18.63-24.77-22.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.26,277.26c6.95,8.26,13.67,17.67,14.08,20,.74,4.17,6.38,38.26,6.38,38.26s1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-12.5-28.68-13-31.38a15.21,15.21,0,0,0-1.47-4.42s-11.85-9.78-19.21-16.48A39.27,39.27,0,0,0,343.26,277.26Z",
    style: {
      fill: "#929292",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.89,300.49c1.62,9.62,5.83,35,5.83,35s1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-11.41-26.18-12.86-30.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.89,300.49c1.62,9.62,5.83,35,5.83,35s1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-11.41-26.18-12.86-30.87Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.89,300.49c1.62,9.62,5.83,35,5.83,35s1.22,3.67,0,6.62-1.23,4.16,0,6.62,1,3.43-1,2-2.21-2-4.42-6.38,1.47-10.79,1.47-10.79-11.41-26.18-12.86-30.87Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66,439.39a2.18,2.18,0,0,1,1.53,1,8.62,8.62,0,0,1,1.33,2.95l3.28-2.95c.32,2.57.54,4.32.59,4.76.25,2.21-2,3.43-4.17,4.66s-6.63,5.77-11.77,2.94C360.7,450.65,372.44,443.47,373.66,439.39Z",
    style: {
      fill: "#929292",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,439.73a6,6,0,0,0,.73-.69,3.75,3.75,0,0,1,1.56,1,5,5,0,0,1,.74,1.62l.15,1.18a14.44,14.44,0,0,0,6.31-.43c0,.17.05.33.08.47.73,4.17-.49,4.42-2.95,5.15s-7.13-.15-10.07,1.11-8.87,1-9.28-1S324,442.18,327.18,439.73Z",
    style: {
      fill: "#929292",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfUse);
export default __webpack_public_path__ + "static/media/terms-of-use.92fdd321f421614fd2563315f7e95a00.svg";
export { ForwardRef as ReactComponent };